// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-983aa384] .vxe-toolbar {\n  padding-left: 0;\n  height: 40px !important;\n}\n", ""]);
// Exports
module.exports = exports;
